import { TextNature } from "../types";

export const getSeverityFromSeparationRate = (rate: number) => {
  if (rate >= 0.5) return TextNature.neutral;
  if (rate >= 0.3) return TextNature.warning;
  return TextNature.negative;
};
